// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__38l07","empty":"ModalGraph_empty__193mG"};